import env from 'env/env';
import { findRouteMatch } from 'route-data/find-route-match';

import { MISSED_OFFERS, UNKNOWN } from 'constants/pageTypes';

export const splitPath = (path = '') =>
  path
    .split('/')
    .filter(segment => segment.length > 0 && `/${segment}` !== env.root)
    .map(segment => segment.toLowerCase());

export const getPageType = (pathname?: string | null | undefined): string => {
  if (!pathname) {
    return UNKNOWN;
  }

  if (pathname.startsWith('/ecom/beforeYouGo') && pathname.includes('missed-offers')) {
    return MISSED_OFFERS;
  }

  return findRouteMatch(pathname)?.pageType ?? UNKNOWN;
};
